import { useState } from 'react';
import { api } from '../api/client';
import { useAuth } from '../api/useAuth';
import { Stack, Row, Text, Button, Input, MobileSheet } from '../ui';

interface Props {
  friend: any;
  onClose: () => void;
}

export function ProposeMeetupModal({ friend, onClose }: Props) {
  const { friend: me } = useAuth();
  const [city, setCity] = useState((me as any)?.currentCity ?? (me as any)?.city ?? '');
  const [date, setDate] = useState(new Date(Date.now() + 86400000).toISOString().slice(0, 16));
  const [venue, setVenue] = useState('');
  const [notes, setNotes] = useState('');
  const [busy, setBusy] = useState(false);
  const [success, setSuccess] = useState(false);

  async function propose() {
    if (!city.trim() || !date) return;
    setBusy(true);
    try {
      await api.createHang(
        city.trim(),
        new Date(date).getTime(),
        [me!.id, friend.id],
        venue.trim() || undefined,
        notes.trim() || undefined,
      );
      setSuccess(true);
    } catch (e: any) { alert(e.message); }
    finally { setBusy(false); }
  }

  return (
    <MobileSheet open={true} onClose={onClose} title={`Propose meetup with ${friend.name}`}>
      <div>
          {success ? (
            <Stack gap={2}>
              <Text variant="small" className="text-positive">✓ Meetup proposed! Check the Hangs tab.</Text>
              <Button variant="primary" size="sm" onClick={onClose}>Done</Button>
            </Stack>
          ) : (
            <Stack gap={3}>
              <Stack gap={1}>
                <Text variant="micro">city</Text>
                <Input value={city} onChange={e => setCity(e.target.value)} placeholder="e.g. London" />
              </Stack>
              <Stack gap={1}>
                <Text variant="micro">date & time</Text>
                <input
                  type="datetime-local"
                  value={date}
                  onChange={e => setDate(e.target.value)}
                  className="h-9 hairline rounded-sm px-2 bg-bg text-sm w-full"
                />
              </Stack>
              <Stack gap={1}>
                <Text variant="micro">venue (optional)</Text>
                <Input value={venue} onChange={e => setVenue(e.target.value)} placeholder="e.g. The Savoy" />
              </Stack>
              <Stack gap={1}>
                <Text variant="micro">notes (optional)</Text>
                <Input value={notes} onChange={e => setNotes(e.target.value)} placeholder="what's the occasion?" />
              </Stack>
              <Row gap={1} justify="end">
                <Button variant="ghost" size="sm" onClick={onClose}>cancel</Button>
                <Button variant="primary" size="sm" disabled={busy || !city.trim()} onClick={propose}>
                  {busy ? 'proposing…' : 'propose meetup'}
                </Button>
              </Row>
            </Stack>
          )}
      </div>
    </MobileSheet>
  );
}
